export default __webpack_public_path__ + "static/media/dcent.a46bd1c3.webp";